import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d540618d-5128-4bee-a774-6aafaab3eb2e/code/memegen-react/src/app/meme/[id]/MemePageClient.tsx");
